import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import type { DepartmentRecord } from "../../shared/types";
import { StaticDataState } from "../components/StaticDataState";
import { fetchDepartments } from "../lib/static-data";

export function DepartmentsPage() {
  const [departments, setDepartments] = useState<DepartmentRecord[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    setError(null);
    void fetchDepartments()
      .then(setDepartments)
      .catch((nextError) => setError(nextError instanceof Error ? nextError.message : "Could not load departments."));
  }, [reloadKey]);

  const sortedDepartments = useMemo(
    () => [...departments].sort((left, right) => left.code.localeCompare(right.code)),
    [departments],
  );

  if (error) {
    return <StaticDataState title="Departments could not load." message={error} error onRetry={() => setReloadKey((value) => value + 1)} />;
  }

  if (departments.length === 0) {
    return <StaticDataState title="Loading departments..." />;
  }

  return (
    <section className="panel stack-lg">
      <div className="section-heading">
        <p className="eyebrow">Departments</p>
        <h1>Browse Dartmouth by department</h1>
      </div>
      <div className="department-table">
        {sortedDepartments.map((department) => (
          <Link key={department.code} className="department-row" to={`/departments/${department.code}/`}>
            <strong>{department.code}</strong>
            <span>{department.name || "Department listing"}</span>
            <small>{department.courseCount} courses</small>
          </Link>
        ))}
      </div>
    </section>
  );
}
